import React, { useState, useEffect, Fragment } from "react";
import { Container, Spinner, Form, Button} from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import SolutionService from "../services/solution.service";

const SubmitSolution = () => {

   const { problemid } = useParams();
   const [solution, setSolution] = useState([]);
   const [errorSubmit, setErrorSubmit] = useState("");
   const [loading, setLoading] = useState([]);

   const {
      register: registerSolution,
      formState: { errors: errorsSolution },
      handleSubmit: handleSubmitSolution,
    } = useForm({
      mode: "onTouched",
      reValidateMode: "onSubmit",
      defaultValues: {
        description: "",
      },
    });

   useEffect(() => { 
      const loadSolution = async (problemid) => { 
        try{
          setLoading(true); 
          const response = await SolutionService.getSolutionByProblem(problemid);
          setSolution(response.data); 
          setLoading(false); 
        }
        catch(error){
          setLoading(false);
        }
        
      }
      loadSolution(problemid);
    }, []);  


  const onSubmitSolution = async (data) => {
      const { description } = data;

      try {
        setErrorSubmit("");
        setLoading(true); 
        const solid = await SolutionService.addSolutionByProblem(problemid, description);
        setLoading(false);    
     } catch (errorSubmit) {
        setLoading(false);
        setErrorSubmit(errorSubmit.response?.data.message);
     }

  };


    if (loading) {
      return (
        <Container>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Container>
      );
    }

   //const primgsrc = `/images/challenges/${problem.problemtypename}.png`;
   

    return( 
      <Fragment>

         <Container className="p-5 rounded-lg m-5">

            <Form onSubmit={handleSubmitSolution(onSubmitSolution)}>
               <Form.Group className="mb-3" controlId="formDescription">
                  <Form.Control type="textarea" placeholder="Description" 
                        {...registerSolution("description", {
                        required: "Solution can't be empty",
                        
                        })}
                  />  
                  {errorsSolution.description && (
                     <Form.Text className="text-danger">
                     {errorsSolution.description.message}
                     </Form.Text>
                  )}                     
               </Form.Group>
               <Button variant="primary" type="submit">
                           Submit Solution 
                </Button>  
               {errorSubmit && (
                           <Form.Text className="text-danger">
                           {errorSubmit}
                           </Form.Text>
                        )}  
            </Form>

         </Container>

      </Fragment>
 
        
    );
};
  
  export default SubmitSolution;